import { render, staticRenderFns } from "./BasicDetail.vue?vue&type=template&id=35b82460&"
import script from "./BasicDetail.vue?vue&type=script&lang=js&"
export * from "./BasicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports